import { TextField } from 'components/form'
import { Box, Flex } from 'components/elements'
import { Button } from 'components/button'
import { FlexWrapCSS, inputStyle, NegativeMargin, wrapStyle } from 'views/Support/SupportForm'
import { ErrorBox, FormBtnWrap, ModalbuttonWrapCss } from 'features/profile/components/EditProfileForm'
import { yupResolver } from '@hookform/resolvers/yup'
import { CircularProgress, FormControl, Tooltip } from '@mui/material'
import { StyledDropdownWrap, StyledLabel } from 'components/form/Textfield.styles'
import { useEffect, useMemo, useState } from 'react'
import { useForm, SubmitHandler, Controller } from 'react-hook-form'
import { PHONE_VALIDATION, ValidationErrors, RegPattern, Stages, TERMINOLOGY } from 'utils/enum'
import * as Yup from 'yup'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import { routes, SectorList } from 'configs/constants'
import { useNavigate } from 'react-router-dom'
import { Form1Props, QuoteDTO } from './type'
import FormWrapper from 'features/auth/components/FormWrapper'
import { userRegHeadingCss } from 'views/style'
import { errorMessage, getUpperCase } from 'utils/function'
import { BackNavArrowIcon } from 'components/icons'
import { useSignupByQuote } from '../api/signupByQuote'
import { AxiosError } from 'axios'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { ToolTipcss } from 'features/incidents/components/style'
import { QouteLayout } from '../page/GetAQuotes'
import { useGetCountries } from 'features/profile/api/countryList'
import { Listing, MenuDropdown } from 'components/menuDropdown'

export const GetAQuoteForm = (props: Form1Props) => {
  const { quoteUserReg, setQuoteUserReg, setStage, apiError } = props
  const user = quoteUserReg?.users
  const [submitError, setSubmitError] = useState('')
  const [phoneNum, setPhoneNumber] = useState<string>(user?.phoneNum || '')
  const [hasError, setHasError] = useState('')
  const [userSelectedContry, setUserSelectedContry] = useState<Listing | undefined>()
  const [userSector, setUserSector] = useState<Listing | undefined>()
  const navigate = useNavigate()
  const { mutate, isLoading } = useSignupByQuote()
  const { data: getCountries, isLoading: isCountriesLoading } = useGetCountries()

  const countryList = useMemo(() => {
    return getCountries?.countries || []
  }, [getCountries])

  const {
    handleSubmit,
    register,
    setValue,
    control,
    formState: { errors },
  } = useForm<QuoteDTO>({
    resolver: yupResolver(getAQoute),
    defaultValues: {
      firstName: user?.firstName || '',
      lastName: user?.lastName || '',
      email: user?.email || '',
      companyName: user?.companyName || '',
      phoneNum: user?.phoneNum || '',
      //user affiliate id or client provided
      merchantAffiliateId: user?.merchantAffiliateId || quoteUserReg?.merchantAffiliateId,
      companyAddress: user?.companyAddress || '',
      companyWebsite: user?.companyWebsite || '',
      country: user?.country || '',
      sector: user?.sector || '',
    },
  })
  useEffect(() => {
    // Set the initial selected country if user has a country
    if (user?.country && countryList.length > 0) {
      const foundCountry = countryList.find((country: { label: (string | null)[] }) => country.label.includes(user?.country))
      setUserSelectedContry({ label: foundCountry?.label, value: foundCountry?.value })
    }
    // Set the initial selected sector if user has a sector
    if (user?.sector) {
      setUserSector({ label: user?.sector, value: user?.sector })
    }
  }, [countryList, user])

  const onSubmit: SubmitHandler<QuoteDTO> = async data => {
    const countryNameOnly = userSelectedContry?.label?.replace(/^[^\w\s]+/g, '').trim()

    if (hasError !== '') return
    setSubmitError('')

    const services = quoteUserReg?.service
    // box partner is paid , skip Payment
    const newObj = {
      ...quoteUserReg,
      ...data,
      country: countryNameOnly,
      email: data.email.trim(),
      paymentPeriod: quoteUserReg?.period,
      services,
    }
    data.merchantAffiliateId
    setQuoteUserReg?.({
      ...quoteUserReg,
      users: {
        ...data,
        country: countryNameOnly ?? '',

        merchantAffiliateId: data.merchantAffiliateId === '' ? null : data.merchantAffiliateId,
      },
      status: true,
    })

    delete newObj.service
    delete newObj.users
    if (newObj.merchantAffiliateId === '') {
      newObj.merchantAffiliateId = null
    }
    mutate(newObj, {
      onSuccess: data => {
        //@ts-expect-error improve type
        setQuoteUserReg?.(prev => ({
          ...prev,
          premiumInfo: {
            premium: (data?.premium ?? 0).toLocaleString(),
            maxCoverage: (data?.maxCoverage ?? 0).toLocaleString(),
            discountPercent: data?.discountedPercentage ?? 0,
            discountValue: (data?.discountedPremium ?? 0).toLocaleString(),
            period: data?.paymentPeriod ?? '',
          },
        }))
        setStage?.(Stages.STAGE5)
      },
      onError: error => {
        if (error instanceof AxiosError) {
          setSubmitError(errorMessage(error))
        }
      },
    })
  }

  const PhoneNumber = (newValue: string | undefined) => {
    if (newValue !== undefined) {
      setPhoneNumber(newValue)
      setValue('phoneNum', newValue, { shouldValidate: true })
      if (isValidPhoneNumber(newValue)) setHasError('')
      else {
        setHasError(PHONE_VALIDATION.PHONEERROR)
      }
    }
  }

  return (
    <>
      <Flex justify="center" css={{ ...QouteLayout, m: '$4 0', pb: '$6' }}>
        <FormWrapper controlWidth={{ maxWidth: 700 }} style={{ textAlign: 'left' }}>
          <Flex align="center">
            <BackNavArrowIcon fontSize={24} style={{ cursor: 'pointer' }} onClick={() => props?.setStage && props.setStage(Stages.STAGE3)} />
            <Flex as="h2" justify={'center'} css={userRegHeadingCss}>
              Get A Quote
            </Flex>
          </Flex>
          <Flex as="form" css={NegativeMargin} direction="column" onSubmit={handleSubmit(onSubmit)}>
            {!!submitError && <ErrorBox css={{ textAlign: 'left', mb: '$3' }}>{getUpperCase(submitError)}</ErrorBox>}
            {!!apiError && <ErrorBox css={{ textAlign: 'left', mb: '$3' }}>{getUpperCase(apiError)}</ErrorBox>}

            <Flex css={FlexWrapCSS}>
              <Box css={wrapStyle}>
                <TextField
                  label="First Name"
                  placeholder="First Name"
                  error={!!errors.firstName}
                  helperText={errors.firstName?.message}
                  {...register('firstName')}
                  css={inputStyle}
                />
              </Box>
              <Box css={wrapStyle}>
                <TextField label="Last Name" placeholder="Last Name" error={!!errors.lastName} helperText={errors.lastName?.message} {...register('lastName')} css={inputStyle} />
              </Box>
            </Flex>
            <Flex css={FlexWrapCSS}>
              <Box css={wrapStyle}>
                <TextField label="Email" placeholder="Email" error={!!errors.email} helperText={errors.email?.message} {...register('email')} css={inputStyle} />
              </Box>
              <Box css={wrapStyle}>
                <TextField
                  label="Company Name"
                  placeholder="Company Name"
                  error={!!errors.companyName}
                  helperText={errors.companyName?.message}
                  {...register('companyName')}
                  css={inputStyle}
                />
              </Box>
            </Flex>
            <Flex css={FlexWrapCSS}>
              <Box css={wrapStyle}>
                <TextField
                  {...register('companyAddress')}
                  placeholder="Enter Company Address"
                  label="Company Address"
                  error={!!errors.companyAddress}
                  helperText={errors.companyAddress?.message}
                  css={inputStyle}
                />
              </Box>
              {/* TODO:Might need it later */}
              {/* <Box css={wrapStyle}>
            <TextField
              {...register('annualRevenue')}
              placeholder="Enter your Annual Revenue($)"
              label="Annual Revenue"
              error={!!errors.companyAddress}
              helperText={errors.companyAddress?.message}
              css={inputStyle}
            />
          </Box> */}
              <Box css={wrapStyle}>
                <TextField
                  {...register('companyWebsite')}
                  placeholder="Enter Company Website"
                  label="Company Website"
                  error={!!errors.companyWebsite}
                  helperText={errors.companyWebsite?.message}
                  css={inputStyle}
                />
              </Box>
            </Flex>
            <Flex css={FlexWrapCSS}>
              <Box css={wrapStyle}>
                <StyledDropdownWrap>
                  <FormControl fullWidth>
                    <Controller
                      name={'sector'}
                      control={control}
                      render={({ field }) => (
                        <MenuDropdown
                          {...field}
                          inputStyle={{ border: errors?.sector ? '1px solid red' : '' }}
                          {...register('sector')}
                          label="Select Industry"
                          placeholder="Select Industry"
                          list={SectorList}
                          value={userSector}
                          setValue={e => {
                            // Update the state with the selected sector object and form field value
                            setUserSector(e)
                            field.onChange(e.value)
                            setValue('sector', e.value)
                          }}
                        />
                      )}
                    />
                    {!!errors.sector && <ErrorBox css={{ textAlign: 'left', mb: '$3' }}>{errors.sector?.message}</ErrorBox>}
                  </FormControl>
                </StyledDropdownWrap>
              </Box>
              <Box css={wrapStyle}>
                <StyledDropdownWrap>
                  <FormControl fullWidth>
                    <Controller
                      name={'country'}
                      control={control}
                      render={({ field }) => (
                        <MenuDropdown
                          {...field}
                          isDisabled={isCountriesLoading}
                          isResponseFetching={isCountriesLoading}
                          inputStyle={{ border: errors?.country ? '1px solid red' : '' }}
                          {...register('country')}
                          label="Select Country"
                          placeholder="Select Country"
                          list={countryList}
                          value={userSelectedContry}
                          setValue={e => {
                            // Update the state with the selected country object
                            setUserSelectedContry(e)
                            field.onChange(e.value)
                            setValue('country', e.value)
                          }}
                        />
                      )}
                    />
                    {!!errors.country && <ErrorBox css={{ textAlign: 'left', mb: '$3' }}>{errors.country?.message}</ErrorBox>}
                  </FormControl>
                </StyledDropdownWrap>
              </Box>
            </Flex>
            <Flex css={FlexWrapCSS}>
              <Box css={wrapStyle}>
                <StyledDropdownWrap style={{ margin: 0, maxWidth: '520px' }} className="phoneNumber">
                  <FormControl fullWidth className={`phoneNumber ${errors.phoneNum && 'phoneNumberError'}`}>
                    <StyledLabel>Phone Number</StyledLabel>
                    <PhoneInput
                      international
                      defaultCountry="US"
                      countryCallingCodeEditable={false}
                      placeholder="Phone number"
                      value={phoneNum}
                      onChange={newValue => {
                        PhoneNumber(newValue)
                      }}
                    />
                  </FormControl>
                  <Box as="p" className="errorText">
                    {hasError}
                  </Box>
                  {!!errors.phoneNum && (
                    <Box as="p" className="errorText">
                      {errors.phoneNum?.message}
                    </Box>
                  )}
                </StyledDropdownWrap>
              </Box>
              <Box css={wrapStyle}>
                <Flex wrap={'wrap'} css={{ columnGap: '10px' }}>
                  <StyledLabel>{TERMINOLOGY.partner.singular} AffiliateId</StyledLabel>
                  <Tooltip
                    PopperProps={{ sx: ToolTipcss }}
                    title={
                      <Box as="span" css={{ color: '$black' }}>
                        This is the affiliate ID for reference of the {TERMINOLOGY.partner.singular.toLowerCase()} through which you came to know of DLT.
                      </Box>
                    }
                    placement="bottom"
                    enterTouchDelay={0}
                  >
                    <Box>
                      <HelpOutlineIcon />
                    </Box>
                  </Tooltip>
                </Flex>

                <TextField
                  readOnly
                  placeholder="Affiliate Id"
                  error={!!errors.merchantAffiliateId}
                  helperText={errors.merchantAffiliateId?.message}
                  {...register('merchantAffiliateId')}
                  css={{ ...inputStyle, opacity: 0.5 }}
                />
              </Box>
            </Flex>

            <Flex css={{ ...ModalbuttonWrapCss, ...FormBtnWrap }}>
              <Button bordered={true} type="button" onClick={() => navigate(routes.login)} size="lg">
                Cancel
              </Button>

              <Button type="submit" size="lg" disabled={isLoading}>
                {isLoading ? (
                  <>
                    <CircularProgress size={19} sx={{ color: 'var(--colors-white)' }} />
                  </>
                ) : (
                  'Next'
                )}
              </Button>
            </Flex>
          </Flex>
        </FormWrapper>
      </Flex>
    </>
  )
}
export const getAQoute = Yup.object().shape({
  firstName: Yup.string()
    .required(ValidationErrors.FIRST_NAME)
    .matches(RegPattern.NO_WHITE_SPACE, ValidationErrors.NO_WHITE_SPACE)
    .matches(RegPattern.FIRST_NAME_VALIDATION, ValidationErrors.FIRST_NAME_VALIDATION),

  lastName: Yup.string()
    .required(ValidationErrors.LAST_NAME)
    .matches(RegPattern.NO_WHITE_SPACE, ValidationErrors.NO_WHITE_SPACE)
    .matches(RegPattern.LAST_NAME_VALIDATION, ValidationErrors.LAST_NAME_VALIDATION),
  email: Yup.string().required(ValidationErrors.EMAIL_VALIDATION).matches(RegPattern.EMAIL_VALIDATION, ValidationErrors.EMAIL_VALIDATION),
  companyName: Yup.string()
    .required(ValidationErrors.COMPANY_NAME)
    .matches(RegPattern.WHITE_SPACE, ValidationErrors.WHITE_SPACE)
    .matches(RegPattern.COMPANY_NAME_VALIDATION, ValidationErrors.COMPANY_NAME_VALIDATION),
  phoneNum: Yup.string().required(ValidationErrors.PHONE),
  merchantAffiliateId: Yup.string().nullable(),
  companyAddress: Yup.string()
    .required(ValidationErrors.ADDRESS)
    .matches(RegPattern.WHITE_SPACE, ValidationErrors.WHITE_SPACE)
    .matches(RegPattern.ADDRESS_VALIDATION, ValidationErrors.ADDRESS_VALIDATION),
  companyWebsite: Yup.string().required(ValidationErrors.WEBSITE_URL).matches(RegPattern.URL_VALIDATION, ValidationErrors.WEBSITE_URL_VALIDATION),
  country: Yup.string().required(ValidationErrors.COUNTRY_NAME),
  sector: Yup.string().required(ValidationErrors.SECTOR),
})
